import { render, staticRenderFns } from "./Separaror.vue?vue&type=template&id=07c75f14&scoped=true&"
import script from "./Separaror.vue?vue&type=script&lang=js&"
export * from "./Separaror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c75f14",
  null
  
)

export default component.exports